import React from 'react';
import { isBbUserView } from '../utils/partnerUser';

interface BbPageHeaderProps {
  title: string;
  subtitle?: string;
}

const isBbPartner = (): boolean => isBbUserView();

/**
 * Standard Blackbaud page header: a white container with a title and subtitle,
 * matching the header pattern used across other BB (YourCause) sections.
 * Renders only when the user is in the Blackbaud iframe experience.
 */
const BbPageHeader: React.FC<BbPageHeaderProps> = ({ title, subtitle }) => {
  if (!isBbPartner()) return null;

  return (
    <div className="bb-page-header-band">
      <div className="bb-page-header">
        <h1 className="bb-page-header-title">{title}</h1>
        {subtitle && <p className="bb-page-header-subtitle">{subtitle}</p>}
      </div>
    </div>
  );
};

export default BbPageHeader;
